import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PageShell } from './components/PageShell';
import { AssessmentPage } from './components/AssessmentPage';
import { ProgramPage } from './components/ProgramPage';
import { initAnalytics } from './services/analytics';
import type { PageKind } from './data/pages';

declare global {
  interface Window { __PAGE__?: { kind: PageKind; id: string } }
}

initAnalytics();

const page = window.__PAGE__;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PageShell>
      {openLead => page?.kind === 'assessment'
        ? <AssessmentPage id={page.id} onLead={openLead} />
        : <ProgramPage id={page?.id ?? ''} onLead={openLead} />}
    </PageShell>
  </StrictMode>
);
